import Request from '@/utils/request'

import { generateRandomString } from '@/utils/common.js'

/** GET 男用户转盘主页 */
export function maleSpinHome() {
  return Request({
    url: '/api/v2/app/male/worldcup/home',
    method: 'get',
    envelope: false,
  })
}

/**
 * POST 男用户抽奖
 * @param {{ poolType: string, spinCount: number, idempotencyKey: string }} body
 */
export function maleSpinDraw(body) {
  return Request({
    url: '/api/v2/app/male/worldcup/draw/spin',
    method: 'post',
    data: body,
    envelope: false,
  })
}

/** GET 男用户抽奖历史 */
export function maleSpinDrawHistory(params) {
  return Request({
    url: '/api/v2/app/male/worldcup/draw/history',
    method: 'get',
    params,
    envelope: false,
  })
}

/** GET 男用户排行榜 */
export function maleSpinLeaderboard() {
  return Request({
    url: '/api/v2/app/male/worldcup/leaderboard',
    method: 'get',
    envelope: false,
  })
}

/** 生成抽奖幂等键（每次点击唯一） */
export function newSpinIdempotencyKey() {
  return `${Date.now()}-${generateRandomString(24)}`
}

export function normalActBaseInfo() {
  return Request({
    url: '/api/v2/app/female/worldcup/home',
    method: 'get',
    envelope: false,
  })
}

export function normalMilesClaim() {
  return Request({
    url: '/api/v2/app/female/worldcup/milestone/claim',
    method: 'post',
    envelope: false,
  })
}

export function normalActRank() {
  return Request({
    url: '/api/v2/app/female/worldcup/rank',
    method: 'get',
    envelope: false,
  })
}
